import React from "react";

const Certificate = ({
  studentName = "John Doe",
  courseName = "React Development",
  completionDate = "08 June 2026",
  certificateId = "CERT-123456",
}) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&family=Outfit:wght@400;600;800&family=Great+Vibes&display=swap');
          
          @media print {
            .no-print {
              display: none !important;
            }
            .certificate-container {
              background: none !important;
              padding: 0 !important;
            }
            .certificate-box {
              box-shadow: none !important;
              border: 15px solid #1e3a8a !important;
            }
          }
        `}
      </style>
      <div style={styles.container} className="certificate-container">
        <div style={styles.certificate} className="certificate-box">
          {/* Subtle watermark */}
          <div style={styles.watermark}>ERAM</div>
          
          <img
            src="/Workforce.svg"
            alt="Workforce Logo"
            style={styles.logo}
          />
          
          <h1 style={styles.title}>Certificate of Completion</h1>

          <p style={styles.presentedTo}>This certificate is proudly presented to</p>

          <h2 style={styles.name}>{studentName}</h2>

          <p style={styles.forCompleting}>for successfully completing the course</p>

          <h3 style={styles.course}>
            {courseName}
          </h3>

          <div style={styles.detailsRow}>
            <p style={styles.detailText}><strong>Completion Date:</strong> {completionDate}</p>
            <p style={styles.detailText}><strong>Certificate ID:</strong> {certificateId}</p>
          </div>

          <div style={styles.footer}>
            <div style={styles.signatureBlock}>
              <div style={styles.signatureLine}></div>
              <p style={styles.signatureText}>Course Instructor</p>
            </div>

            {/* A small seal or badge could go here */}
            <div style={styles.seal}>
              <div style={styles.sealInner}>
                ★
              </div>
            </div>

            <div style={styles.signatureBlock}>
              <div style={styles.signatureLine}></div>
              <p style={styles.signatureText}>Authorized Signatory</p>
            </div>
          </div>

          <button onClick={handlePrint} style={styles.button} className="no-print">
            Download / Print Certificate
          </button>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    background: "#f8fafc",
    fontFamily: "'Outfit', sans-serif",
  },
  certificate: {
    position: "relative",
    width: "850px",
    padding: "60px 80px",
    border: "12px solid #1e3a8a",
    outline: "4px solid #d4af37",
    outlineOffset: "-20px",
    background: "#ffffff",
    textAlign: "center",
    borderRadius: "2px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-30deg)",
    fontSize: "180px",
    fontWeight: "900",
    color: "rgba(30, 58, 138, 0.03)",
    pointerEvents: "none",
    fontFamily: "'Cinzel', serif",
    zIndex: 0,
    letterSpacing: "20px",
  },
  logo: {
    width: "180px",
    height: "auto",
    marginBottom: "30px",
    position: "relative",
    zIndex: 1,
  },
  title: {
    color: "#1e3a8a",
    fontSize: "46px",
    fontFamily: "'Cinzel', serif",
    fontWeight: "700",
    letterSpacing: "2px",
    margin: "0 0 30px 0",
    position: "relative",
    zIndex: 1,
  },
  presentedTo: {
    fontSize: "18px",
    color: "#64748b",
    letterSpacing: "1px",
    textTransform: "uppercase",
    margin: "0",
    position: "relative",
    zIndex: 1,
  },
  name: {
    fontFamily: "'Great Vibes', cursive",
    fontSize: "64px",
    color: "#0f172a",
    margin: "15px 0 25px 0",
    fontWeight: "normal",
    position: "relative",
    zIndex: 1,
  },
  forCompleting: {
    fontSize: "16px",
    color: "#64748b",
    fontStyle: "italic",
    margin: "0",
    position: "relative",
    zIndex: 1,
  },
  course: {
    color: "#1e3a8a",
    fontSize: "32px",
    margin: "25px 0 40px 0",
    fontWeight: "800",
    letterSpacing: "0.5px",
    position: "relative",
    zIndex: 1,
  },
  detailsRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 40px",
    marginBottom: "50px",
    position: "relative",
    zIndex: 1,
  },
  detailText: {
    fontSize: "15px",
    color: "#334155",
    margin: "0",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
    padding: "0 20px",
    position: "relative",
    zIndex: 1,
  },
  signatureBlock: {
    width: "200px",
  },
  signatureLine: {
    borderBottom: "1px solid #1e3a8a",
    marginBottom: "10px",
  },
  signatureText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1e3a8a",
    margin: "0",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  seal: {
    width: "80px",
    height: "80px",
    background: "#d4af37",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 10px rgba(212, 175, 55, 0.4)",
  },
  sealInner: {
    width: "66px",
    height: "66px",
    border: "2px dashed #fff",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "24px",
  },
  button: {
    marginTop: "50px",
    padding: "12px 28px",
    background: "linear-gradient(135deg, #2563eb, #1e3a8a)",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
    transition: "transform 0.2s, box-shadow 0.2s",
    position: "relative",
    zIndex: 1,
  },
};

export default Certificate;
